<template>
  <div class="cert-list-empty">
    <img
      class="cert-list-empty-img"
      src="@/assets/images/profile/empty_state_cert.png"
    />
    <h6 class="dashboard__tab-title cert-list-empty__title">
      You don't have any certifications yet.
    </h6>
    <p class="cert-list-empty__info">
      Widely recognized by hiring managers and organizations around the world,
      IT certifications help demonstrate your skills as you look to accelerate
      or kickstart your career.
    </p>
    <div class="cert-list-empty__btn-wrapper">
      <router-link :to="{ name: 'certifications' }" class="btn btn--primary"
        >INE Certifications</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificationsListEmpty',
}
</script>

<style lang="scss">
.cert-list-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--white);
  text-align: center;
  @include desktop {
    max-width: 900px;
  }
  &__title {
    text-align: center;
    margin: 0 0 10px 0 !important;
  }
  &__info {
    text-align: center;
    font-size: rem(16);
    line-height: 24px;
    color: var(--light-blue-gray);
  }
  &__btn-wrapper {
    margin: 10px auto 0 auto;
  }
  &-img {
    width: 100%;
    max-height: 315px;
    object-fit: contain;
    @include tablet {
      width: unset;
    }
  }
}
</style>
